module.exports = __webpack_public_path__ + "static/media/logo_stay4golf.a364a44f.png";